import React from "react";
// import Aren from "../../assets/logos/arken.svg";
import Nucsys from "../../assets/logos/nucsys.svg";
import Skolanalysis from "../../assets/logos/skolanalysis.svg";
import BrainStar from "../../assets/logos/brainstar-echo.svg";
import ComponentDB from "../../assets/logos/component-db.svg";
import Everglow from "../../assets/logos/everglow.svg";
import ScrollAnimation from "react-animate-on-scroll";

const Credits = () => {
  return (
    <>
      <section className="md:py-24 py-12">
        <div className="container sm:container md:container lg:container w-full mx-auto">
          <h2 className="md:text-4xl text-3xl font-semibold leading-normal text-blue-800 text-center font-avenirHeavy">
            Our credits
          </h2>
          <ScrollAnimation animateIn="fadeIn">
            <div className="pt-10">
              <div className="w-12/12 mx-auto">
                <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-4 w-full">
                  <div className="md:my-0 my-2">
                    <img
                      src={Nucsys}
                      alt="NUCSYS"
                      title="NUCSYS"
                      className="mx-auto"
                    />
                  </div>
                  <div className="md:my-0 my-2">
                    <img
                      src={Everglow}
                      alt="Everglow360"
                      title="Everglow360"
                      className="mx-auto"
                    />
                  </div>
                  <div className="md:my-0 my-2">
                    <img
                      src={ComponentDB}
                      alt="ComponentDB"
                      title="ComponentDB"
                      className="mx-auto"
                    />
                  </div>
                  <div className="md:my-0 my-2">
                    <img
                      src={Skolanalysis}
                      alt="Skolanalysis"
                      title="Skolanalysis"
                      className="mx-auto"
                    />
                  </div>
                  <div className="md:my-0 my-2">
                    <img
                      src={BrainStar}
                      alt="BrainStar"
                      title="BrainStar"
                      className="mx-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </section>
    </>
  );
};

export default Credits;
